<template>
    <transition name="fade">
        <div class="resend-code">
            <span v-if="resendLoading" class="spinner-circle resend"></span>
            <a v-else class="resend-link" @click="resend">{{ resendText }}</a>
        </div>
    </transition>
</template>

<script>
export default {
    name: 'ResendLink',
    props: {
        resendLoading: {
            type: Boolean,
            default: false,
        },
        resendLinkText: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            resendText: this.resendLinkText || this.$t('resend'),
        };
    },
    methods: {
        resend() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="less" scoped>
.resend-code {
    text-align: center;
    a {
        line-height: 50px;
        cursor: pointer;
        text-decoration: underline;
    }
    .resend {
        margin-top: 14px;
    }
}
.murk {
    .resend-code {
        .resend {
            margin-top: 12px;
        }
    }
}
</style>
